module.exports = __webpack_public_path__ + "img/360.ec7e567d.svg";